import { render, staticRenderFns } from "./VusoPolicyCancel.vue?vue&type=template&id=562eaabf&scoped=true&"
import script from "./VusoPolicyCancel.vue?vue&type=script&lang=js&"
export * from "./VusoPolicyCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562eaabf",
  null
  
)

export default component.exports